import { useCallback, useState, useEffect } from 'react';
import '../useDebounce/useDebounce.js';
import useWindowSize from '../useWindowSize/useWindowSize.js';

const useResponsive = breakpoints => {
  const [width, height] = useWindowSize({
    wait: 500
  });
  const sizes = Object.entries(breakpoints).sort(([_, aSize], [_1, bSize]) => bSize - aSize);
  if (sizes[sizes.length - 1][1] !== 0) {
    sizes[sizes.length - 1][1] = 0;
  }
  const getScreen = useCallback(() => {
    const size = sizes.find(([_, s]) => s < width)[0];
    const orientation = width > height ? 'landscape' : 'portrait';
    return {
      width,
      size,
      orientation,
      screenIsAtLeast(breakpoint, andOrientation) {
        return width >= breakpoints[breakpoint] && (!andOrientation || andOrientation.includes(orientation));
      },
      screenIsAtMost(breakpoint, andOrientation) {
        return width <= breakpoints[breakpoint] && (!andOrientation || andOrientation.includes(orientation));
      }
    };
  }, [breakpoints, height, sizes, width]);
  const [screen, setScreen] = useState(getScreen());
  useEffect(() => {
    const onResize = () => {
      const current = getScreen();
      if (current.width !== screen.width || current.size !== screen.size || current.orientation !== screen.orientation) {
        setScreen(current);
      }
    };
    onResize();
  }, [width, screen, setScreen, getScreen]);
  return screen;
};

export default useResponsive;
